import { type ResultOf } from '@graphql-typed-document-node/core'
import { atomWithReset } from 'jotai/utils'

import { graphql } from '~/gql'
import {
  type StandardAnalysisPage_CustomerAttributeTabulationMutationMutationVariables as CustomerAttributeMutationVariables,
  type StandardAnalysisPage_QuestionTabulationMutationMutationVariables as QuestionMutationVariables,
} from '~/gql/graphql'

export const isTabulationReadyAtom = atomWithReset(false)
export const isPendingTabulationAtom = atomWithReset(false)

const questionTabulationQueryDataFragment = graphql(`
  fragment StandardAnalysisPage_QuestionTabulationQueryData on CountAnswersByMultiQuestionsResult {
    groupCounts
    results {
      questionId
      groupAnswers {
        answers {
          answerOption {
            option
            text
          }
          count
        }
        group
      }
    }
  }
`)

const customerAttributeTabulationQueryDataFragment = graphql(`
  fragment StandardAnalysisPage_CustomerAttributeTabulationQueryData on CountBySingleCustomerAttributeResult {
    byCustomerAttributeId
    result {
      totalCount
      brands {
        brandGroupId
        brandNumber
        result {
          count
          segmentNumber
        }
      }
    }
  }
`)

type TabulationQueryData = {
  question: ResultOf<typeof questionTabulationQueryDataFragment> | null
  customerAttributes:
    ResultOf<typeof customerAttributeTabulationQueryDataFragment>[] | null
}
export const tabulationQueryDataAtom =
  atomWithReset<TabulationQueryData | null>(null)

type TabulationVariables = {
  question: QuestionMutationVariables
  customerAttributes: CustomerAttributeMutationVariables
}
export const lastTabulatedVariablesAtom =
  atomWithReset<TabulationVariables | null>(null)
